import { DqlQuery, Query } from '../field';

export class ContractNumber {

  readonly id: Query.OrderField;
  readonly number: Query.OrderField;

  constructor(prefix?: string) {
    prefix = prefix ? prefix : '';
    this.id = new DqlQuery.OrderField(prefix + 'id');
    this.number = new DqlQuery.OrderField(prefix + 'number');
  }

}
